(function() {
    let menuSocket = null;
    game.services.socket = {
        getMenuSocket: function() {
            return menuSocket;
        },
        connectMenuSocket: function(component) {
            if (game.isPlayScreen || game.isMobile) {
                return;
            }

            if (menuSocket) {
                menuSocket.disconnect();
            }

            let token = Cookies.get('token');
            let query = {};
            let name = window.localStorage.getItem('name');
            if (name && name.trim().length) {
                query.name = name;
            }
            if (token) {
                query.userToken = token;
            }

            menuSocket = io(API_URL, {
                query: query,
                reconnection: true,
                transports: ['websocket'],
                upgrade: false
            });

            game.appComponent.updateIsPlayScreen(true);

            component.$root.$emit('menuSocketCreated', menuSocket);
        },
        disconnectMenuSocket: function() {
            if (menuSocket) {
                menuSocket.disconnect();
            }
        }
    };
})();